import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useSpring, animated } from '@react-spring/web'
import image1 from '../../assets/images/clouds/Asset 11 1.png';
import image2 from '../../assets/images/clouds/Asset 12 1.png';
import image3 from '../../assets/images/clouds/Asset 13 1.png';
import image4 from '../../assets/images/clouds/Asset 14 1.png';
import image5 from '../../assets/images/clouds/Asset 15 1.png';
import image6 from '../../assets/images/clouds/Asset 16 1.png';
import image7 from '../../assets/images/clouds/Asset 17 1.png';
import image8 from '../../assets/images/clouds/Asset 18 1.png';
import './CloudSmall.scss';

const images = [
	image1,
	image2,
	image3,
	image4,
	image5,
	image6,
	image7,
	image8
];

export const CloudSmall = memo(props => {
	const { className, amplitude, distance, offset, type } = props;
	const src = images[type];
	const styleInner = {
		transform: `translateX(${amplitude}%)`,
	};
	const styleOuter = useSpring({
		transform: `translateX(${offset / distance}%)`,
	});

	return (
		<animated.div style={styleOuter} className={className}>
			<img style={styleInner} src={src} className="cloud-inner" />
		</animated.div>
	);
});

CloudSmall.propsTypes = {
	className: PropTypes.string,
	amplitude: PropTypes.number,
	distance: PropTypes.number,
	offset: PropTypes.number,
	type: PropTypes.number,
};
